import { NAV_LINKS } from '@/config/navigation'
import { Link } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'

interface IMobileNavigationProps {
  onClick: () => void
}

export function MobileNavigation({ onClick }: IMobileNavigationProps) {
  const t = useTranslations('Navigation')

  return (
    <nav>
      <ul className="mx-auto flex flex-col gap-3">
        {NAV_LINKS.map((link) => (
          <li
            key={link.label}
            className="text-body-2 text-primary-600 border-b border-b-gray-200 px-2 py-2.5 leading-6"
          >
            <Link onClick={onClick} href={link.href}>
              {t(link.label)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
